import { extendTheme } from "@chakra-ui/react";

export const theme = extendTheme({
    colors: {
        yellow: {
            dark: "#c49b63",
            darker: "#997748",
        },
        gray: {
            bg: "#120f0f",
        }

    }
});
